module.exports = __webpack_public_path__ + "static/img/main.7a2cb6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main.jpg
// module id = DOw+
// module chunks = 30